<template>
  <div class="">
    <!-- 音量放大组件 -->
    <Amplification v-if="show_ampli" @hide="show_ampli = false" />
    <!-- 作品拼接组件 -->
    <Joint v-if="show_joint" @hide="show_joint = false" />
    <!-- 音频变音组件 -->
    <Umlaut v-if="show_umlaut" @hide="show_umlaut = false" />
    <!-- 去水印组件 -->
    <Watermark v-if="show_mate" @hide="show_mate = false" />
    <!-- 加背景音组件 -->
    <addBgmusci v-if="show_addbg" @hide="show_addbg = false"/>
    <!-- 音频修改组件 -->
    <AudioAmend v-if="show_amend" @hide="show_amend = false"/>
    <!-- 格式转换组件 -->
    <AudioFormat v-if="show_format" @hide="show_format = false"/>
    <img src="../../assets/images/img2/toolsbanner.png" class="tools_banner" />
    <div class="con">
      <div class="index_mod1top animated">
        <div class="index_mod1text">
          <p class="index_mo1tit1">音频工具</p>
          <p class="index_mo1tit2">定制您的专属配音作品</p>
        </div>
        <div class="index_mod1bg"></div>
      </div>
      <div class="index_mod4list">
        <div class="index_mod4li toolsli" @click="showAudioAmend">
          <img src="../../assets/images/index_ypxg.png" />
          <div>
            <p class="index_mod4litit">音频修改</p>
            <p class="index_mod4litext">修改采样率等属性</p>
          </div>
        </div>
        <div class="index_mod4li toolsli" @click="showFormatAudio">
          <img src="../../assets/images/index_sw.png" />
          <div>
            <p class="index_mod4litit">格式转换</p>
            <p class="index_mod4litext">改变文件格式类型</p>
          </div>
        </div>
        <div class="index_mod4li toolsli" @click="showAmpli">
          <img src="../../assets/images/index_yl.png" />
          <div>
            <p class="index_mod4litit">音量放大</p>
            <p class="index_mod4litext">增强音频文件音量</p>
          </div>
        </div>
        <div class="index_mod4li toolsli" @click="showJoint">
          <img src="../../assets/images/index_pj.png" />
          <div>
            <p class="index_mod4litit">作品拼接</p>
            <p class="index_mod4litext">多个配音作品拼接</p>
          </div>
        </div>
        <div class="index_mod4li toolsli" @click="showUmlaut">
          <img src="../../assets/images/index_by.png" />
          <div>
            <p class="index_mod4litit">音频变音</p>
            <p class="index_mod4litext">改变音频主播音色</p>
          </div>
        </div>
        <div class="index_mod4li toolsli" @click="showAddbg">
          <img src="../../assets/images/index_jbg.png" />
          <div>
            <p class="index_mod4litit">加背景音</p>
            <p class="index_mod4litext">作品添加背景音乐</p>
          </div>
        </div>
        <!-- <div class="index_mod4li toolsli">
          <img src="../../assets/images/index_cj.png" />
          <div>
            <p class="index_mod4litit">音频剪裁</p>
            <p class="index_mod4litext">仅保留需要的部分</p>
          </div>
        </div> -->
      </div>
    </div>
    <div class="con">
      <div class="index_mod1top animated">
        <div class="index_mod1text">
          <p class="index_mo1tit1">视频工具</p>
          <p class="index_mo1tit2">增强您的视频处理效果</p>
        </div>
        <div class="index_mod1bg"></div>
      </div>
      <div class="index_mod4list">
        <div class="index_mod4li toolsli marB" @click="showMate">
          <img src="../../assets/images/index_qsy.png" />
          <div>
            <p class="index_mod4litit">去水印</p>
            <p class="index_mod4litext">清除短视频水印</p>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
// 音量放大组件
import Amplification from "../../components/tools/amplification.vue";
// 作品拼接组件
import Joint from "../../components/tools/joint.vue";
// 音频变音组件
import Umlaut from "../../components/tools/umlaut.vue";
// 去水印组件
import Watermark from "../../components/tools/watermark.vue";
// 加背景音组件
import addBgmusci from "../../components/tools/add_bgmusci.vue";
// 音频修改组件
import AudioAmend from "../../components/tools/audio_amend.vue"
// 格式转换组件
import AudioFormat from "../../components/tools/audio_format.vue"
// 底部组件
import Footer from "../../components/footer.vue";
export default {
  components: {
    Amplification,
    Joint,
    Umlaut,
    Watermark,
    addBgmusci,
    Footer,
    AudioAmend,
    AudioFormat
  },
  data() {
    return {
      show_ampli: false, //音量放大组件显示状态
      show_joint: false, //作品拼接组件显示状态
      show_umlaut: false, //音频变音组件显示状态
      show_mate: false, //去水印组件显示状态
      show_addbg: false, //背景音乐组件显示状态
      show_amend:false,//音频修改组件显示状态
      show_format:false,//格式转换组件显示状态
    };
  },
  methods: {
    showAudioAmend(){
      // 判断登录状态
      if (this.$globalFun.judgeNotLogin(this)) return;
      this.show_amend = true;
    },
    showAmpli() {
      // 判断登录状态
      if (this.$globalFun.judgeNotLogin(this)) return;
      this.show_ampli = true;
    },
    showJoint(){
      // 判断登录状态
      if (this.$globalFun.judgeNotLogin(this)) return;
      this.show_joint = true;
    },
    showUmlaut(){
      // 判断登录状态
      if (this.$globalFun.judgeNotLogin(this)) return;
      this.show_umlaut = true;
    },
    showMate(){
      // 判断登录状态
      if (this.$globalFun.judgeNotLogin(this)) return;
      this.show_mate = true;
    },
    showAddbg(){
      // 判断登录状态
      if (this.$globalFun.judgeNotLogin(this)) return;
      this.show_addbg = true;
    },
    showFormatAudio(){
      // 判断登录状态
      if (this.$globalFun.judgeNotLogin(this)) return;
      this.show_format = true;
    }
  },
};
</script>

<style scoped>
@import url("../../assets/css/tools.css");
.marB{
    margin-bottom: 75px;
}
</style>



// WEBPACK FOOTER //
// src/view/tools/tools.vue